export const errorMessages = function(code='9999') {
  switch (code) {
    case '404':
      return 'Record Not Found'
    default:
      return 'Unknown'
  }
}